import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"
import { defaultFormulaConfig } from "../helpers/allowance_defaults"

// The Zulagen list of a Zulagen-Profil: the "+ Zulage hinzufügen" menu, creating a Zulage
// (the server answers with the same turbo_stream as the template builder) and drag-and-drop
// reordering. The cards themselves are field-editor controllers, as in the template editor.
export default class extends Controller {
  static targets = ["canvas", "emptyState", "menu"]

  static values = {
    createUrl: String,
    reorderUrl: String,
    createError: String,
    newAllowanceFallback: String,
  }

  connect() {
    this.outsideClick = (event) => {
      if (!this.hasMenuTarget || this.menuTarget.contains(event.target)) return
      if (event.target.closest('[data-action*="allowance-list#toggleMenu"]')) return
      this.menuTarget.classList.add("hidden")
    }
    document.addEventListener("click", this.outsideClick)
    this.initSortable()
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClick)
    this.sortable?.destroy()
  }

  // The create turbo_stream replaces the canvas when the first Zulage arrives, so the
  // Sortable is rebuilt whenever a canvas connects.
  canvasTargetConnected() {
    this.initSortable()
  }

  toggleMenu(event) {
    event.preventDefault()
    this.menuTarget.classList.toggle("hidden")
  }

  async addAllowance(event) {
    event.preventDefault()
    const { allowanceType, allowanceName } = event.currentTarget.dataset
    this.menuTarget.classList.add("hidden")

    try {
      const response = await fetch(this.createUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']")?.content,
          Accept: "text/vnd.turbo-stream.html",
        },
        body: JSON.stringify({
          timesheet_template_allowance: {
            name: allowanceName || this.newAllowanceFallbackValue,
            allowance_type: allowanceType,
            formula_config: defaultFormulaConfig(allowanceType),
          },
        }),
      })
      if (!response.ok) throw new Error(`HTTP ${response.status}`)

      Turbo.renderStreamMessage(await response.text())
      if (this.hasEmptyStateTarget) this.emptyStateTarget.classList.add("hidden")
    } catch (error) {
      console.error("Error creating allowance:", error)
      window.Turbo?.toast?.(this.createErrorValue, "error")
    }
  }

  initSortable() {
    this.sortable?.destroy()
    this.sortable = null
    if (!this.hasCanvasTarget || !this.hasReorderUrlValue) return

    this.sortable = new Sortable(this.canvasTarget, {
      animation: 150,
      handle: ".drag-handle",
      ghostClass: "opacity-50",
      chosenClass: "bg-green-50",
      dragClass: "shadow-lg",
      onEnd: () => this.reorder(),
    })
  }

  reorder() {
    const positions = Array.from(this.canvasTarget.children).map((item, index) => ({
      id: item.id.replace("timesheet_template_allowance_", ""),
      position: index + 1,
    }))

    fetch(this.reorderUrlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']")?.content,
        Accept: "application/json",
      },
      body: JSON.stringify({ positions }),
    }).catch((error) => console.error("Error reordering:", error))
  }
}
